interface SearchForm {
  root: HTMLElement;
  input: HTMLInputElement | null;
  resetButton: HTMLElement | null;
}

export const searchForms: SearchForm[] = [
  ...(<NodeListOf<HTMLElement>>document.querySelectorAll(".js-search-form")),
].map((root): SearchForm => {
  return {
    root,
    input: <HTMLInputElement | null>root.querySelector(".js-search-form-input"),
    resetButton: root.querySelector(".js-search-form-reset"),
  };
});

const initSearchForm = (searchForm: SearchForm) => {
  searchForm.resetButton?.addEventListener("click", () => {
    if (searchForm.input) {
      searchForm.input.value = "";
      searchForm.input.defaultValue = "";
    }
  });
};

searchForms.forEach(initSearchForm);
